import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import useDebounce from '../../../hooks/useDebounce';

const TextAreaInput = ({
  id,
  handleInputChange,
  metaTag,
  fileIndex,
  tagIndex,
  userInput,
}) => {
  const [localFormInput, setLocalFormInput] = useState(userInput);
  const debouncedUserInput = useDebounce(localFormInput, 500);

  //Effect to monitor changes after a copy action
  useEffect(() => {
    setLocalFormInput(userInput);
  }, [userInput]);

  //Effect to update debounced userInput
  useEffect(() => {
    handleInputChange(fileIndex, tagIndex, debouncedUserInput);
  }, [debouncedUserInput]);

  return (
    <Form.Control
      value={localFormInput}
      as={'textarea'}
      id={metaTag.meta.id}
      key={`${fileIndex}_${tagIndex}_${metaTag.meta.id}`}
      maxLength={metaTag.attributes.maxlength}
      onChange={(e) => {
        setLocalFormInput(e.target.value);
      }}
    />
  );
};

export default TextAreaInput;
